<template>
  <div :class="[`kv_item_cla`, `label_text_${type}`]">
    <label>{{ label }}:</label>
    <span class="value-cla">
      <slot></slot>
    </span>
  </div>
</template>

<script>
export default {
  name: 'ZkKvLine',
  data() {
    return {}
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    type: {
      validator(value) {
        // return this.oneOf(value, ['default', 'primary', 'info', 'success', 'warning', 'error'])
      }
    }
  },
  mounted() {},
  methods: {
    oneOf(val, arr) {
      if (arr.includes(val)) {
        return arr.includes(val)
      }
    }
  }
}
</script>

<style scoped lang="less">
@import '~@/styles/var.less';
.label_text_default {
  color: #303133;
}
.label_text_primary {
  color: #7ac143;
}
.label_text_info {
  color: #909399;
}
.label_text_success {
  color: #67c23a;
}
.label_text_warning {
  color: #e6a23c;
}
.label_text_warning {
  color: #f56c6c;
}
.kv_item_cla {
  padding: 5px;
  width: 100%;
  min-height: 20px;
  box-sizing: border-box;
  // float: left;
  display: flex;
  label {
    display: inline-block;
    width: 240px;
    padding-right: 20px;
    text-align: right;
    white-space: nowrap;
    box-sizing: border-box;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.9);
  }
  .value-cla {
    color: @fontColor3;
  }
}
@media screen and(min-width: 1024px) {
  .kv_item_cla {
    padding: 10px 0 10px 10px;
    label {
      padding-right: 7px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/cdpBase/baseComponents/kvLine/src/main.vue